import React, { useState, useEffect } from "react";
import "react-swipeable-list/dist/styles.css";
import { Tabs, Tab } from "react-bootstrap";
import MenuBottomBar from "../../v2/menuBottomMobile";
import { isIphone, setBodyBackgroundGrey } from "../../../../helpers/common";
import NoMessagesMob from "../NoMessagesMob";
import {
  SCROLL_DIRECTION_DOWN,
  SCROLL_DIRECTION_UP,
} from "../../../../constants/common";
import { usePrevious } from "../../../../hooks/usePrevious";
import { useNavigate } from "react-router-dom";
import DirectMessageLeftSection from "../../../../components/Messages/DirectMessageLeftSection";
import TopHeader from "../../common/TopHeader";
import { usePremium } from "@/hooks";

const DirectMessagesWrapper = (props) => {
  const messages = props.messages;

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const { shouldToggleColor } = usePremium();

  useEffect(() => {
    setLoading(false);
  }, [messages]);

  useEffect(() => {
    document
      .getElementById("scroll-chain")
      .classList.remove("scroll-chaining-fix");
    setBodyBackgroundGrey();
    window.addEventListener("scroll", handleScroll); // attaching scroll event listener
  }, []);
  const [scrollDirection, setScrollDirection] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const prevScrollPosition = usePrevious(scrollPosition);

  const handleScroll = () => {
    const isBottom =
      Math.ceil(window.innerHeight + window.scrollY) >=
      document.documentElement.scrollHeight;

    if (!isBottom && window.scrollY > 5) {
      setScrollPosition(window.scrollY);
    }
  };

  useEffect(() => {
    if (messages) {
      if (
        scrollPosition > prevScrollPosition &&
        scrollDirection !== SCROLL_DIRECTION_DOWN
      ) {
        setScrollDirection(SCROLL_DIRECTION_DOWN);
      } else if (
        scrollPosition < prevScrollPosition &&
        scrollDirection !== SCROLL_DIRECTION_UP
      ) {
        setScrollDirection(SCROLL_DIRECTION_UP);
      }
    }
  }, [scrollPosition]);

  let mainWrapperClass = "gitcha-main-wrapper windowscroll-fix messages";
  let contentWrapperClass =
    "content-wrapper content-wrapper-h-102-percent windowscroll-fix";
  if (scrollDirection === SCROLL_DIRECTION_DOWN) {
    if (isIphone()) {
      mainWrapperClass = "gitcha-main-wrapper pad-btm-0 windowscroll-fix";
    } else {
      mainWrapperClass = "gitcha-main-wrapper pad-btm-0 windowscroll-fix";
    }
    contentWrapperClass =
      "content-wrapper content-wrapper-h-102-percent windowscroll-fix";
  }

  return (
    <>
      {messages && messages.length > 0 ? (
        <div className={mainWrapperClass}>
          <div className={contentWrapperClass}>
            <TopHeader
              variant="threeComp"
              outerClassname="bg-white"
              topClassName="w-100 flex-column top-three-comp-headerborder"
              bottomClassName="w-100"
            >
              <div></div>
              <div
                className={shouldToggleColor ? "heading-premium" : "heading"}
              >
                Messages
              </div>
              <div className="p-0 toplinks-mobile">
                <a className=" social-btns-wrap" href={void 0}></a>
              </div>
            </TopHeader>
          </div>

          {scrollDirection !== SCROLL_DIRECTION_DOWN && (
            <div className="inner-layout-footer-new inner-layout-footer-topfix">
              <MenuBottomBar
                scrollDirection={scrollDirection}
                noScrollBounce={true}
              />
            </div>
          )}
        </div>
      ) : (
        <NoMessagesMob isDM={true} />
      )}
      <div className="h-100 inner-layout-content-new position-relative">
        <div className="view-client-wrap mobile-msg-tab">
          <div className="tab-wrap tab-wrap-fix">
            <Tabs
              defaultActiveKey="direct-msg"
              id="uncontrolled-tab-example"
              className="mb-3"
              onSelect={(key) => {
                if (key === "direct-msg") {
                  navigate("/direct-messages");
                } else {
                  navigate("/messages");
                }
              }}
            >
              <Tab eventKey="intro-msg" title="Introduction Message">
                {/* <div className=" ">
                  {messages &&
                    messages.length > 0 &&
                    messages.map((msg, index) => (
                      <Contact
                        key={msg.IntroductionId}
                        id={msg.IntroductionId}
                        msgData={msg}
                        index={index}
                        selectedIntroductionId={props.selectedIntroductionId}
                        userId={props.userId}
                        handleWantAdSelection={(msgData) => {
                          props.handleWantAdSelection(msgData);
                        }}
                        setUIKey={setUIKey}
                      />
                    ))}
                </div> */}
              </Tab>
              <Tab eventKey="direct-msg" title="Direct Message">
                <DirectMessageLeftSection messages={messages} />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectMessagesWrapper;
